import auth from '@/router/auth'
import HomeIndex from '@/components/home/Index'
import HomeAdminIndex from '@/components/home/IndexAdmin'

export default [
  {
    path: '/',
    name: 'home-index',
    component: HomeIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/dashboard',
    name: 'home-admin-index',
    component: HomeAdminIndex,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/home/router.js